
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkCalculationitemTypeEnum } from '../models/work-calculationitem-type-enum';
import { WorkCalculationTemplateVariableRoundModeEnum } from '../models/work-calculation-template-variable-round-mode-enum';

export function getCreateCalculationTemplateItemDtoFormGroup() {
return new FormGroup({
    calculationTemplateId: new FormControl<number | undefined>(undefined, [Validators.required]),
    calculationTemplateGroupId: new FormControl<number | undefined>(undefined, [Validators.required]),
    itemId: new FormControl<number | undefined>(undefined),
    itemDescription: new FormControl<string | undefined>(undefined),
    unitId: new FormControl<number | undefined>(undefined),
    type: new FormControl<WorkCalculationitemTypeEnum | undefined>(undefined),
    discountPercentage: new FormControl<number | undefined>(undefined),
    optional: new FormControl<boolean | undefined>(false),
    targetAmount: new FormControl<number | undefined>(undefined),
    purchaseChf: new FormControl<number | undefined>(undefined),
    materialSalePrice: new FormControl<number | undefined>(undefined),
    workSalePrice: new FormControl<number | undefined>(undefined),
    saleChf: new FormControl<number | undefined>(undefined),
    saleChfExcl: new FormControl<number | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
    sortOrder: new FormControl<number | undefined>(undefined),
    variableKey: new FormControl<string | undefined>(undefined, [Validators.maxLength(100), Validators.pattern(new RegExp("^[a-zA-Z][a-zA-Z0-9_]*$", ""))]),
    variableFactor: new FormControl<number | undefined>(1),
    variableRoundMode: new FormControl<WorkCalculationTemplateVariableRoundModeEnum | undefined>(undefined),
})
;
}
      